import angular from 'angular';
import profileImages from './profileImages';

export default angular
  .module('components.profileImages', [])
  .component('profileImages', profileImages).name;
